const e = {
  add: "Añadir",
  cancel: "Cancelar",
  clear: "Borrar",
  confirm: "Confirmar",
  delete: "Borrar",
  redo: "Rehacer",
  save: "Guardar",
  saveAs: "Guardar como",
  undo: "Deshacer"
}, a = {
  clear: "Borrar",
  confirm: "Confirmar",
  datePlaceholder: "Seleccionar fecha",
  datetimePlaceholder: "Seleccionar fecha y hora",
  endDatePlaceholder: "Fecha de finalización",
  endDatetimePlaceholder: "Fecha y hora de finalización",
  endMonthPlaceholder: "Final de mes",
  monthPlaceholder: "Seleccionar mes",
  now: "Ahora",
  quarterPlaceholder: "Seleccionar Trimestre",
  selectDate: "Seleccionar fecha",
  selectTime: "Seleccionar hora",
  startDatePlaceholder: "Fecha de inicio",
  startDatetimePlaceholder: "Fecha de inicio y hora",
  startMonthPlaceholder: "Mes de inicio",
  today: "Hoy",
  weekPlaceholder: "Seleccionar semana",
  yearPlaceholder: "Seleccione Año"
}, o = {
  placeholder: "Seleccione"
}, r = {
  clear: "Borrar",
  negativeText: "Cancelar",
  now: "Ahora",
  placeholder: "Seleccionar hora",
  positiveText: "De acuerdo"
}, c = {
  placeholder: "Introduzca"
}, l = {
  placeholder: "Introduzca"
}, n = {
  placeholder: "Comience a escribir..."
}, s = {
  allRows: "Todas las filas",
  default: "Por defecto",
  deleteLayoutDescription: "¿Seguro que desea eliminar este diseño?",
  discardChanges: "Descartar cambios",
  discardLayoutChanges: "Descartar los cambios de diseño",
  enterLayoutName: "Introduzca el nombre del diseño",
  enterRowNumber: "Introduzca el número de filas",
  fieldsSelected: "campos seleccionados",
  freezeColumnDescription: "Congelar la columna a la izquierda",
  freezeUptoColumn: "Congele hasta la columna",
  frozen: "Congelado",
  layoutName: "Nombre del diseño",
  manageColumns: "Gestionar columnas",
  none: "Ninguno",
  reorderRows: "Reordenar Filas",
  rowsSelected: "filas seleccionadas",
  saveLayoutAs: "Guardar diseño como",
  saveLayoutNew: "Guardar nuevo diseño",
  search: "Buscar",
  searchColumnsPlaceholder: "Buscar columnas",
  searchFieldsPlaceholder: "Buscar campos",
  selectAll: "Seleccionar todo",
  setTableHeight: "Establecer la altura de la mesa",
  unfreeze: "Descongelar",
  unsavedChanges: "Tiene cambios sin guardar",
  unsavedChangesDescription: "Puede que haya uno o más cambios sin guardar. ¿Desea guardarlos?"
}, t = {
  at: "en",
  colorAlreadyUsed: "Seleccionar un color diferente o usar el actual",
  colorNamePlaceholder: "Introducir el nombre",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Por favor, seleccione un nombre de color distinto",
  noColorsAdded: "No tiene ningún color en esta sección."
}, i = {
  searchPlaceholder: "Buscar"
}, d = {
  invalidPastedData: "Datos pegados no válidos"
}, u = {
  of: "de",
  page: "Página",
  rowsPerPage: "Filas por página"
}, h = {
  failedToUpload: "Error al subir",
  retry: "Reintentar",
  clickToUpload: "hacer clic para subir",
  orDragAndDrop: "O Arrastra y suelta",
  supportedFileTypes: "Tipos de archivo compatibles:"
}, m = {
  global: e,
  DatePicker: a,
  Select: o,
  TimePicker: r,
  Input: c,
  InputNumber: l,
  InputTag: n,
  HLDataTable: s,
  ColorPicker: t,
  InputPhone: i,
  InputOtp: d,
  Pagination: u,
  Upload: h
};
export {
  t as ColorPicker,
  a as DatePicker,
  s as HLDataTable,
  c as Input,
  l as InputNumber,
  d as InputOtp,
  i as InputPhone,
  n as InputTag,
  u as Pagination,
  o as Select,
  r as TimePicker,
  h as Upload,
  m as default,
  e as global
};
